<template>
  <div class="mydevice-bd">
    <div class="product-wrap">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-button type="primary" icon="el-icon-plus" @click="onAddBtn" v-if="funcView.partner_detail_bankCard_add">{{ $t('Common.com_add') }}</el-button>
          </el-form-item>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column ref="column"></custom-column>
          </el-form-item>
          <!-- 搜索项 -->
          <el-form-item style="float: right">
            <search-input v-model="formSearch.search" :placeholder="$t('crm_partner-bankCard.khmyhzh')" @fetch="onPageChange({ page: 1 })"></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          ref="tb1"
          v-loading="isLoading"
          :size="allTableSize"
          :data="tableList"
          tableCode="bank_card_list"
          height="100%"
          :index="true"
          @filter="filterChange"
          @sort="sortChange"
          @column="setColumn"
          :slots="['action']"
        >
          <template v-slot:action="scope">
            <el-button type="text" size="mini" @click="onEditBtn(scope.row)" v-if="funcView.partner_detail_bankCard_edit">{{ $t('Common.com_edit') }}</el-button>
            <el-button type="text" size="mini" @click="onDefaultBtn(scope.row.bankcardId)" v-if="funcView.partner_detail_bankCard_default && !scope.row.isDefault">{{ $t('crm_partner-bankCard.she_wei_mo_ren') }}</el-button>
            <!-- 更多操作 -->
            <el-dropdown style="vertical-align: top" v-show="scope.row.showMoreAction">
              <el-button type="text" size="mini">
               <span>{{ $t('Common.com_more_action') }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="onDeleteBtn(scope.row.bankcardId)" v-if="funcView.partner_detail_bankCard_delete">{{ $t('Common.com_delete') }} {{ showMore(scope.row) }}</el-dropdown-item>
                <el-dropdown-item @click.native="onDisableBtn(scope.row.bankcardId)" v-if="funcView.partner_detail_bankCard_disable && scope.row.state">
                  {{ $t('Common.com_disable') }} {{ showMore(scope.row) }}
                </el-dropdown-item>
                <el-dropdown-item @click.native="onEnableBtn(scope.row.bankcardId)" v-if="funcView.partner_detail_bankCard_enable && !scope.row.state">
                  {{ $t('Common.com_enable') }} {{ showMore(scope.row) }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
      </div>
    </div>
    <!--添加银行卡-->
    <bank-card-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList"></bank-card-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
// import waitdevice from './waitdevice.vue';
import bankCardDialog from '@/pages/crm/components/bankCardDialog.vue';

export default {
  components: { bankCardDialog },
  props: ['partnerOrgId', 'partnerId', 'partnerType'],
  data() {
    return {
      // tableCode: 'service_hire',
      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        partnerType: '',
        partnerId: '',
        businessLicense: '',
      },
      // 银行卡管理
      dialogVisible: false,
      dialogModel: {},

      tableList: [],
      totalRows: null,
    };
  },
  mounted() {
    this.formSearch.partnerOrgId = this.partnerOrgId;
    // 租赁方ID
    // this.formSearch.partnerId = this.partnerId;
    // this.formSearch.partnerType = this.partnerType;
    this.resetFormSearch = JSON.stringify(this.formSearch);
    // this.getTableColumn();
    this.getFuncView('/customer/renterDetail');
    this.getTableList();
  },
  methods: {
    // 更多操作
    showMore: function (row) {
      this.$set(row, 'showMoreAction', true);
      return '';
    },
    // 获取我的设备列表
    getTableList: function () {
      this.isLoading = true;
      this.$getJSON(apis.crmCrmPartnerBankcardPage, this.formSearch).then((res) => {
        this.isLoading = false;
        const list = res.data.records;
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    onAddBtn() {
      this.dialogModel = {
        type: 'add',
        title: this.$t('Common.com_add'),
        partnerOrgId: this.partnerOrgId,
      };
      this.dialogVisible = true;
    },
    // 编辑银行卡
    onEditBtn: function (item) {
      // alert(3);
      this.dialogVisible = true;
      this.dialogModel.title = this.$t('Common.com_edit');
      this.dialogModel.type = 'edit';
      this.dialogModel.data = { item };

      // this.dialogModel.id = item.bankcardId;
    },
    // 删除
    onDeleteBtn: function (bankcardId) {
      this.$showConfirm(this.$t('crm_partner-bankCard.nqdyscxzdyhkm'))
        .then(() => {
          this.$deleteJSON(`${apis.partnerBankcardDelete}/${bankcardId}`).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_delete_success'),
                type: 'success',
              });
              this.getTableList();
            }
          });
        })
        .catch(() => {});
    },
    // 设为默认
    onDefaultBtn: function (bankcardId) {
      this.$showConfirm(this.$t('crm_partner-bankCard.nqdyjxzdyhkswmryhkm'))
        .then(() => {
          this.$postJSON(`${apis.partnerBankcardDefualt}/${bankcardId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 设为禁用
    onDisableBtn: function (bankcardId) {
      this.$showConfirm(this.$t('crm_partner-bankCard.nqdyjyxzdyhkm'))
        .then(() => {
          this.$postJSON(`${apis.PartnerBankcardDisableOrEnable}/${bankcardId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 启用
    onEnableBtn: function (bankcardId) {
      this.$showConfirm(this.$t('crm_partner-bankCard.nqdyqyxzdyhkm'))
        .then(() => {
          this.$postJSON(`${apis.PartnerBankcardDisableOrEnable}/${bankcardId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },

    // 切换页
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
.mydevice-bd {
  height: 100%;
  display: flex;
  flex-direction: column;
  .product-info {
    position: relative;
    background-color: #ffffff;
    height: 220px;
    display: flex;
    .g2-p1 {
      width: 500px;
      height: 220px;
    }
    .g2-p2 {
      width: 460px;
      height: 200px;
      .g2-legend {
        height: 120px !important;
        width: 800px !important;
        max-width: 800px !important;
      }
      .g2-legend-list {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height: 100%;
      }
      .g2-legend-list-item {
        width: 120px;
      }
    }
  }
  .product-wrap {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
    margin: 10px;
    background-color: #ffffff;
  }
  .card-bd {
    flex: 1;
    height: 0;
    overflow-y: auto;
    ul {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 218px;
        height: 247px;
        border-radius: 2px;
        border: 1px solid rgba(233, 233, 233, 1);
        margin-right: 12px;
        margin-bottom: 10px;
        text-align: center;
        position: relative;
        padding: 10px;
        .btn-del {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 10px;
          top: 8px;
          cursor: pointer;
        }
        .btn-edit {
          position: absolute;
          color: #666666;
          font-size: 15px;
          left: 35px;
          top: 8px;
          cursor: pointer;
        }
        .status {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 28px;
          color: #ffffff;
          width: 50px;
          font-size: 12px;
          background-color: #00afff;
          border-bottom-left-radius: 24px;
          text-align: right;
          padding-right: 8px;
        }
        .img-box {
          font-size: 0;
          height: 180px;
          img {
            display: inline-block;
            width: 160px;
            height: 160px;
          }
        }
        h1 {
          color: #00afff;
          font-size: 18px;
          font-weight: bold;
          line-height: 25px;
        }
        p {
          margin-top: 5px;
          font-size: 12px;
          line-height: 17px;
        }
      }
    }
  }
}
</style>
